/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ContractType {
    DEAL = 'DEAL',
    SIDE_LETTER = 'SIDE_LETTER',
    MULTISIGNATURE = 'MULTISIGNATURE',
    FORM = 'FORM',
}
